import React from "react";
import { Box, Grid, styled } from "@mui/material";
import DeviceIcon from "../../images/devices icon.png";
import UserIcon from "../../images/user icon.png";
import StarIcon from "../../images/star icon.png";
import { InfoItemBox, SubTitle, Text } from "./style";

const RootStyle = styled(Box)(({ theme }) => ({
  background: "#FAFAFA",
  minHeight: "40vh",
  padding: "0 83px",
  [theme.breakpoints.down("md")]: {
    padding: "0 15px 30px 15px",
  },
}));

function InfoSection() {
  return (
    <RootStyle>
      <Grid
        container
        spacing={5}
        sx={{ display: "flex", justifyContent: "center" }}
      >
        <Grid item sm={3} xs={12}>
          <InfoItemBox>
            <img width="56px" height="56px" src={DeviceIcon} alt="" />

            <Box sx={{ display: "flex" }}>
              <SubTitle>Multi</SubTitle>
              <SubTitle sx={{ mx: 0.5 }}>-</SubTitle>
              <SubTitle sx={{ color: "#4CAF50" }}>Device</SubTitle>
            </Box>
            <Text>Use on any device: Desktop, Mobile Phone or Laptop</Text>
          </InfoItemBox>
        </Grid>
        <Grid item md={3} xs={12}>
          <InfoItemBox>
            <img width="56px" height="56px" src={UserIcon} alt="" />

            <Box sx={{ display: "flex" }}>
              <SubTitle>Multi</SubTitle>
              <SubTitle sx={{ mx: 0.5 }}>-</SubTitle>
              <SubTitle sx={{ color: "#4CAF50" }}>User</SubTitle>
            </Box>
            <Text>
              Mange your workforce and employees through limited access
            </Text>
          </InfoItemBox>
        </Grid>
        <Grid item md={3} xs={12}>
          <InfoItemBox>
            <img width="56px" height="56px" src={StarIcon} alt="" />

            <Box sx={{ display: "flex" }}>
              <SubTitle>Rated</SubTitle>
              <SubTitle sx={{ mx: 0.5 }}>-</SubTitle>
              <SubTitle sx={{ color: "#4CAF50" }}>4.8/5</SubTitle>
            </Box>
            <Text>Rated by our happy customers</Text>
          </InfoItemBox>
        </Grid>
      </Grid>
    </RootStyle>
  );
}

export default InfoSection;
